module.exports = __webpack_public_path__ + "img/nodeicon.034ec977.svg";